define(
    'viewmodels/secured/uploads/tabs/recipients/recipients',[
        "viewmodels/ViewModelNotification",
        "viewmodels/secured/uploads/context",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModelNotification, ctx, dataProvider, i19n) {
        var grid = null;
        var $grid = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            folderShareId: ko.observable()
        });

        vm.activate = function () {
            vm.folderShareId(sessionStorage.getItem("upload-request-id"));
     
            if (grid) {
                grid.dataSource.read();
            }
        };
        vm.attached = function () {
            $grid = $("#upload-request-details-recipient-grid");

            buildKendoGrid();

            function buildKendoGrid() {
                var columns = [
                    { field: "documentShareRecipientId", hidden: true },
                    { field: "recipient", title: i19n.to.recipient, width: 200 },
                    { field: "organisation", title: i19n.to.organisation },
                    { field: "uploadCount", title: i19n.to.uploads, width: 170 },
                    //{
                    //    command: [
                    //        {
                    //            text: i19n.to.resend,
                    //            click: function (e) {
                    //                e.preventDefault();

                    //                //var itm = this.dataItem($(e.currentTarget).closest("tr"));

                    //                //dataProvider.documents
                    //                //.resendDocumentShareEmailLink(vm.folderShareId(), itm.documentShareRecipientId)
                    //                //.done(function () {
                    //                //    vm.notify(1, i19n.to.resendemaildocumentsharelinkdone);
                    //                //})
                    //                //.fail(function (e) {
                    //                //    e.stopPropagation = true;
                    //                //    vm.notify(e.error);
                    //                //});

                    //                return false;
                    //            }
                    //        }
                    //    ],
                    //    title: '&nbsp;',
                    //    width: 80
                    //}
                ];                

                grid = $grid.kendoGrid({
                    excel: {
                        allPages: true,
                        fileName: "upload-request-recipient-details.xlsx"
                    },
                    dataBound: function () {
                        resizeGrid();
                    },
                    dataSource: getKendoGridDataSource(),
                    resizable: true,
                    sortable: true,
                    columns: columns,
                    scrollable: true
                }).data("kendoGrid");
            }
            function getKendoGridDataSource() {
                var schema = {
                    model: {
                        id: "folderShareRecipientId",
                        fields: {
                            folderShareRecipientId: { type: "string" },
                            recipient: { type: "string" },
                            organisation: { type: "string" },
                            //downloaded: { type: "date" }
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            ctx.loadForUploadRequestDetails(vm.folderShareId())
                            .done(function (data) {
                                var r = _.map(data.recipients, function (itm) {
                                    itm.uploadCount = itm.documents.length;

                                    return itm;
                                });

                                callbacks.success(r);

                                setTimeout(function () {
                                    resizeGrid();
                                }, 500);
                            })
                            .fail(function (e) {
                                console.error(e);
                            });
                        }
                    },
                    schema: schema,
                    pageSize: 999
                });

            }
            
            $(window).on("resize", _.debounce(resizeGrid, 250));
        };

        vm.exportToExcel = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                grid.saveAsExcel();

                complete();
            }
        });

        return vm;

        function resizeGrid() {
            if (!$grid)
                return;

            var newGridHeight = $("#upload-request-details-content").outerHeight() - 355;

            $grid.height(newGridHeight);

            grid.resize();
        }
    }
 );

